// useUserRoles.js
// Custom hook for role management
import { useMemo } from 'react';
import { StorageKey } from '../auth/DataService';

const useUserRoles = () => {
  const supplier = localStorage.getItem(StorageKey.token_SupplierId);
  const rolesString = localStorage.getItem(StorageKey.userInfo_ett_group);
  const roles = useMemo(
    () => (rolesString ? rolesString.split(',') : []),
    [rolesString]
  );
  const country = localStorage.getItem(StorageKey.token_Country);

  return useMemo(() => {
    const hasRole = (role) => roles.includes(role);
    return {
      supplier,
      country,
      isAdmin: hasRole('DPLP.LP_Admin'),
      isKeyUser: hasRole('DPLP.DP_Vessel_Journal_Key_User'),
      isMarketUser: hasRole('DPLP.DP_Vessel_Journal_Market_User'),
      isShippingCompanyUser: hasRole('DPLP.DP_Vessel_Journal_Shipping_Company'),
      isPortOperatorUser: hasRole('DPLP.DP_Vessel_Journal_Port_Operator'),
      hasUnrestrictedAccess:
        hasRole('DPLP.LP_Admin') || hasRole('DPLP.DP_Vessel_Journal_Key_User'),
    };
  }, [roles, supplier, country]);
};

export default useUserRoles;
